<template>
    <div>
        <!--
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        -->
        <v-data-table :headers="headers"
                      :items="array_docs"
                      :options.sync="pagination"
                      :server-items-length="total"
                      loading-text="Cargando..."
                      no-data-text="No hay registros a mostrar."
                      :loading="loading"
                      :footer-props="{
        itemsPerPageOptions: [5, 10, 20, 50, 100],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
        itemsPerPageText:'Registros por página'
      }"
                      :single-expand="true"
                      :expanded.sync="expanded"
                      class="elevation-1 mt-3">

            <template v-slot:item.actions="{ item }">
                <v-btn class="ma-1"
                       outlined
                       x-small
                       fab
                       title="Firmar"
                       @click="verDocumento(item)"
                       v-if="item.id_paquete">
                    <v-icon>mdi-draw</v-icon>
                </v-btn>

                <v-btn class="ma-1"
                       outlined
                       x-small
                       fab
                       title="Eliminar"
                       @click="deleteNotification(item)">
                    <v-icon>mdi-close-thick</v-icon>
                </v-btn>


            </template>
            <!--
            show-expand
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">{{item.mensaje}} </td>
            </template>
            -->
        </v-data-table>


    </div>
</template>



<script>

    import axios from "axios";

    export default {
        name: 'App',
        data: function () {

            return {
                selected_check: [],
                i: 0,

                search: '',
                carpeta_id: "",
                array_docs: [],
                expanded: [],
                headers: [
                    // { text: 'Id', sortable: true, value: 'id',},
                    { text: 'Mensaje', sortable: true, value: 'mensaje', },
                    { text: 'Fecha', sortable: true, value: 'fecha_formateada', },
                    { text: 'Acción', value: 'actions', sortable: false },
                    { text: '', value: 'data-table-expand' },
                ],
                options: {},
                categories: [],
                total: 0,
                loading: false,
                pagination: {},
                selected: [],
            };
        },
        computed: {

        },
        watch: {
            pagination: {
                handler() {
                    this.getCategoriesByPagination();
                },
                deep: true,
            },
            search: {
                handler() {
                    this.getCategoriesByPagination();
                },
                deep: true,
            },
        },
        created() {

        },
        mounted() {

        },
        methods: {
            handleClick(item) {
                if (item.id_paquete) {
                    this.verDocumento(item);
                }
            },
            async recorrer() {

                for (this.i; this.i < this.selected_check.length; this.i++) {


                    let getdoc = axios.delete('Notificacion/Eliminar/' + this.selected_check[this.i], { 'headers': this.$store.state.user.headers })


                    getdoc.then((callback) => {
                        let item_array = this.array_docs.findIndex(v => v.id == this.selected_check[this.i]);
                        if (callback.status == 200) {
                            this.array_docs.splice(item_array, 1);
                            this.$store.state.user.notificaciones_count--;
                            //this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text:'Notificación '+this.selected_check[this.i]+ ' eliminada' });

                        }
                    }).catch((error) => {
                        //this.selected_check = [];
                        this.$store.dispatch('SHOW_ERROR', { show: true, type: 'error', text: 'Hubo un error en el proceso. ' });
                        console.log(error);
                    });


                }
                this.selected_check = [];


            },
            getCategoriesByPagination() {
                this.loading = true;

                // get by search keyword
                if (this.search) {
                    let getdoc = axios.get('Notificacion/listar_paginacion?u=c&query=' + this.search + '&page=' + this.pagination.page + '&per_page=' + this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
                    return getdoc.then(res => {
                        this.array_docs = res.data.items;
                        this.total = res.data.total;
                        this.$store.state.user.notificaciones_count = res.data.total;
                        this.buscarDocumento(this.array_docs);
                    })
                        .catch(err => console.log(err.response.data))
                        .finally(() => this.loading = false);
                }
                // get by sort option
                if (!this.search && this.pagination.sortBy) {
                    const direction = this.pagination.sortDesc[0] ? 'desc' : 'asc';
                    let getdoc = axios.get('Notificacion/listar_paginacion?carpeta_id=' + this.carpeta_id + '&direction=' + direction + '&sortBy=' + this.pagination.sortBy + '&page=' + this.pagination.page + '&per_page=' + this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
                    return getdoc.then(res => {
                        this.loading = false;
                        this.array_docs = res.data.items;
                        this.total = res.data.total;
                        this.$store.state.user.notificaciones_count = res.data.total;
                        this.buscarDocumento(this.array_docs);
                    })
                        .catch(err => console.log(err.response.data))
                        .finally(() => this.loading = false);
                }
                if (!this.search && !this.pagination.sortBy) {
                    let getdoc = axios.get('Notificacion/listar_paginacion?carpeta_id=' + this.carpeta_id + '&page=' + this.pagination.page + '&per_page=' + this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
                    return getdoc.then(res => {
                        this.array_docs = res.data.items;
                        this.total = res.data.total;
                        this.$store.state.user.notificaciones_count = res.data.total;
                        this.buscarDocumento(this.array_docs);
                    })
                        .catch(err => console.log(err.response.data))
                        .finally(() => this.loading = false);
                }
            },
            async deleteNotification(item) {

                let getdoc = axios.delete('Notificacion/Eliminar?id=' + item.id, { 'headers': this.$store.state.user.headers })

                return getdoc.then((callback) => {
                    let item_array = this.array_docs.findIndex(v => v.id == item.id);
                    if (callback.status == 200) {
                        this.array_docs.splice(item_array, 1);
                        this.$store.state.user.notificaciones_count--;
                        this.$store.dispatch('SHOW_ERROR', { show: true, type: 'success', text: 'Notificación ' + item.id + ' eliminada' });
                    }
                }).catch((error) => {
                    this.selected = [];
                    this.$store.dispatch('SHOW_ERROR', { show: true, type: 'error', text: 'Hubo un error en el proceso. ' });
                    console.log(error);
                });
            },
            verDocumento(item) {
                this.$router.push({ 'name': 'documento_edit', params: { 'opt': 'firmar', 'id': item.id_paquete }, query: { 'u': this.makeid(4) } });
            },
            buscarDocumento(array) {
                let it = 0;
                let id_doc;
                array.forEach(element => {
                    if (element.mensaje.includes('Firmar documento')) {
                        id_doc = element?.paquete_id;
                        // console.log("elemnto: ",element.mensaje.split(' ')[2]);
                        console.log('elemento: ', id_doc);
                        this.array_docs[it].id_paquete = id_doc;
                    }
                    it++;
                });
            },
            makeid(l) {
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < l; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },
        }
    };
</script>